import {create} from "zustand";
import {IUserData} from "./IUserData";

export interface IUserState {
    user: IUserData,
    setUser: (newData: IUserData) => void
}

export const userStore = create<IUserState>()((set) => ({
    user: {
        id_e: "",
        birth: "",
        firstName: "",
        gender: "",
        lastName: "",
        phone: "",
        country: "",
        snils: "",
        middleName: "",
        email: "",
        roles: [],
    },
    setUser: (newData) => set((state) => ({user: newData})),
}))

export interface IFileState {
    files: any,
    setFiles: (newData: any) => void
}

export const filesStore = create<IFileState>()((set) => ({
    files: {},
    setFiles: (newData) => set((state) => ({files: newData})),
}))